// Material UI
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

import states from "../../../Utilities/States";
import brands from "../../../Utilities/Brands";

const GenerateOptOutSearchFormProperty = (
  brandId,
  setBrandId,
  addressLine1,
  setAddressLine1,
  addressLine2,
  setAddressLine2,
  city,
  setCity,
  state,
  setState,
  zip,
  setZip,
  
) => {

  const allStates = [...[{ id: "all", name: "All States" }], ...states];

  const formLabels = [
    {
      Label: "Brand",
      Element: "FormControl",
      Value: brandId,
      Setter: setBrandId,
      Data:
      <>
      <option value="" key="-1" />
      <option value="0" key="0">All</option>
        {brands.map((card, _idx) => {
          return (
            <option key={card._id} value={card._id}>
              {card.brand}
            </option>
          );
        })}
      </>
    },
    {
      Label: "Address Line 1",
      Element: "TextField",
      Value: addressLine1,
      Setter: setAddressLine1,
    },
    {
      Label: "Address Line 2",
      Element: "TextField",
      Value: addressLine2,
      Setter: setAddressLine2,
    },
    {
      Label: "City",
      Element: "TextField",
      Value: city,
      Setter: setCity,
    },
    {
      Label: "State",
      Element: "FormControl",
      Value: state,
      Setter: setState,
      Data: 
      <>
        <option value="" />
        {allStates.map((state, idx) => (  
          <option key={idx} value={state.id}>
            {state.name}
          </option>            
        ))}
      </>
    },
    {
      Label: "Zip",
      Element: "TextField",
      Value: zip,
      Setter: setZip,
    },
  ];

  return formLabels.map(
    ({ Label, Element, Type, Data, Value, Setter }, idx) => {
      switch (Element) {
        case "TextField":
          return (
            <TextField
              key={idx}
              id="outlined-full-width"
              className="input-el"
              label={Label}
              type={Type}
              style={{ margin: 8, width: "14rem" }}
              fullWidth={false}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            />
          );
        case "FormControl":
          return (
            <FormControl
              key={idx}
              variant="outlined"
              style={{ margin: 8, width: "14rem" }}
              value={Value}
              onChange={(e) => Setter(e.target.value)}
            >
              <InputLabel htmlFor="outlined-age-native-simple">
                {Label}
              </InputLabel>
              <Select
                native={true}
                label={Label}
                value={Value}
                inputProps={{
                  name: `${Label.toLowerCase()}`,
                  id: `outlined-${Label.toLowerCase()}-native-simple`,
                }}
              >
                {Data}
              </Select>
            </FormControl>
          );
        default:
          return null;
      }
    }
  );
};

export default GenerateOptOutSearchFormProperty;
